import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";
import UsersList from "../Components/UsersList";
import ButtonBack from "../Components/ButtonBack";
import SearchInput from "../Components/SearchInput";

class UsersListPage extends Component {
    getCurrentCustomer() {
        const { stores, customerId } = this.props;
        const customer = stores.data.CustomersStore.findById(customerId);
        return customer;
    }

    onAddClicked() {
        const { stores } = this.props;
        let newUser = stores.data.UsersStore.add();

        const customer = this.getCurrentCustomer();
        if (customer) {
            // set customer id
            newUser.CustomerId = customer.Id;
            newUser.Password = newUser.generatePassword();

            const hash = `#user-detail?id=${newUser.Id}`;
            window.location.hash = hash;
        }
    }

    render() {
        const { stores } = this.props;
        const { search } = stores.ui.view.parameters;

        const customer = this.getCurrentCustomer();
        let customerName = "";
        if (customer) customerName = customer.Name;

        // Primary/admin buttons
        let addButton = null;
        if (stores.currentUser.user.isPrimaryUser || stores.currentUser.user.isAdmin) {
            addButton = (
                <Button bsStyle="success" onClick={this.onAddClicked.bind(this)}>
                    <Glyphicon glyph="plus" />
                    <span>Add</span>
                </Button>
            );
        }

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>

                <div className="row">
                    <h1>Users for {customerName}</h1>
                </div>

                <div className="row">
                    <div className="pull-left">
                        <SearchInput />
                    </div>
                    <div className="pull-right">{addButton}</div>
                </div>

                <div className="row">
                    <UsersList usersStore={stores.data.UsersStore} stores={stores} filter={search} />
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(UsersListPage));



// WEBPACK FOOTER //
// ./src/Pages/UsersListPage.js